<template>
  <component
    :is="link ? 'a' : 'div'"
    class="filter-logo"
    :href="link ? link[$i18n.locale] || link.default : null"
    :target="link ? '_blank' : null"
  >
    <img :src="src" class="filter-logo__img" alt="Logo" />
  </component>
</template>

<script>
export default {
  name: 'FilterLogo',
  props: {
    link: {
      type: Object,
      required: false,
      default: null,
    },
    src: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-logo {
  display: flex;

  &__img {
    max-width: 100%;
    height: 20px;
  }
}
</style>
